import React from 'react';
import { motion } from 'framer-motion';
export function DonutChart() {
  // Data for the chart
  const data = [{
    label: 'Active',
    value: 65,
    color: '#10b981'
  }, {
    label: 'Trial',
    value: 20,
    color: '#34d399'
  }, {
    label: 'Paused',
    value: 10,
    color: '#64748b'
  }, {
    label: 'Churned',
    value: 5,
    color: '#94a3b8'
  } // Slate 400
  ];
  // Calculate circumference and offsets
  const size = 200;
  const strokeWidth = 25;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  let currentOffset = 0;
  return <div className="relative flex items-center justify-center" data-id="element-17">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="rotate-[-90deg]" data-id="element-18">
        {data.map((item, index) => {
        const strokeDasharray = `${item.value / 100 * circumference} ${circumference}`;
        const strokeDashoffset = -currentOffset;
        currentOffset += item.value / 100 * circumference;
        return <motion.circle key={item.label} cx={size / 2} cy={size / 2} r={radius} fill="transparent" stroke={item.color} strokeWidth={strokeWidth} strokeDasharray={strokeDasharray} strokeDashoffset={strokeDashoffset} strokeLinecap="round" initial={{
          strokeDasharray: `0 ${circumference}`
        }} whileInView={{
          strokeDasharray: strokeDasharray
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          delay: index * 0.2,
          ease: 'easeOut'
        }} className="drop-shadow-lg" data-id="element-19" />;
      })}
      </svg>

      {/* Center Text */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none" data-id="element-20">
        <motion.span className="text-3xl font-bold text-white" initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 1,
        duration: 0.5
      }} data-id="element-21">
          85%
        </motion.span>
        <motion.span className="text-xs text-slate-400 uppercase tracking-wider" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 0.5
      }} data-id="element-22">
          Retention
        </motion.span>
      </div>
    </div>;
}